import PropTypes from 'prop-types';

const sidebarPropTypes = {

    /** reportID in the current navigation state */
    reportIDFromRoute: PropTypes.string,
};
export default sidebarPropTypes;
